// extracted by mini-css-extract-plugin
export default {"root":"Description_root__fmQ6d"};